<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Stripe Coupons</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search in stripe coupons..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('stripeCouponId')">Stripe Coupon Id</th>
              <th class="col-1" @click="toggleSort('stripeConfigurationId')">Stripe Configuration Id</th>
              <th class="col-1" @click="toggleSort('stripeCouponCode')">Stripe Coupon Code</th>
              <th class="col-1" @click="toggleSort('couponId')">Coupon Id</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.stripeCouponId">
              <td class="col-1 text-truncate" v-html="truncateText(config.stripeCouponId, 30)" @click="selectText" :data-text="config.stripeCouponId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.stripeConfigurationId, 30)" @click="selectText" :data-text="config.stripeConfigurationId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.stripeCouponCode, 30)" @click="selectText" :data-text="config.stripeCouponCode"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.couponId, 30)" @click="selectText" :data-text="config.couponId"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'StripeCouponEdit', params: { id: config.couponId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";

export default {
  name: "StripeCoupons",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      StripeCouponsList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
    };
  },
  computed: {
    filteredStripeCouponsList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.StripeCouponsList.filter((config) => {
        return (
            (config.stripeCouponId && config.stripeCouponId.toString().includes(search)) ||
            (config.stripeConfigurationId && config.stripeConfigurationId.toString().includes(search)) ||
            (config.stripeCouponCode && config.stripeCouponCode.toLowerCase().includes(search)) ||
            (config.couponId && config.couponId.toString().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      return filteredList;
    },
    sortData() {
      return this.filteredStripeCouponsList;
    },
  },
  created() {
    this.doLoadPlans();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    this.sortColumn = 'stripeCouponId';
  },
  methods: {
    doLoadPlans() {
      AdminService.getStripeCouponsList().then((data) => {
        this.StripeCouponsList = data;
      }).catch((error) => {
        console.error("Error loading stripe coupons:", error);
      });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      return text.length > limit ? text.substring(0, limit) + '...' : text;
    },
    redirectToCreate() {
      this.$router.push({ name: 'StripeCouponCreate' }); // Navigate to the StripeEdit route without params
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    }
  },
};
</script>
<style src="../../assets/style.css">
</style>
